import styled from 'styled-components';

export const ODSpecificationStyles = styled.section``;
